import type {
  OnboardingCompanyRequest,
  OnboardingCompanyResponse
} from '@tandemone/types'

import { api } from '@/api/client'

export async function createCompany(
  body: OnboardingCompanyRequest
): Promise<OnboardingCompanyResponse> {
  const { data } = await api.post<OnboardingCompanyResponse>(
    '/v1/onboarding/company',
    body
  )
  return data
}
